export const FALLING = 'falling', RISING = 'rising', HOLD = 'hold', SETUP = 'setup', HIGH = 'high', LOW = 'low', VALID = "valid";
export const VHIGH = 'v_high', VLOW = 'v_low', VINH = 'vinh', VINL = 'vinl';
export const OVERSHOOT = 'overshoot', UNDERSHOOT = 'undershoot';